/* esm.sh - bs58check@4.0.0 */
export * from "/*bs58check@4.0.0/esnext/bs58check.mjs";
export { default } from "/*bs58check@4.0.0/esnext/bs58check.mjs";
